export default __webpack_public_path__ + "static/media/User.86829eb3.svg";